import { App } from '@/types';
import projectsData from '@/data/minddockai_projects.json';

export const apps: App[] = [
  {
    id: 'lie',
    name: 'Lie Detector',
    nameZh: 'AI谎言检测器',
    description: 'AI-powered lie detection game that analyzes your responses',
    descriptionZh: '基于AI技术的谎言检测游戏，智能分析你的回答并判断真假',
    url: 'https://lie.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🎭',
    featured: false,
    color: 'from-pink-500 to-purple-600',
    gradient: 'linear-gradient(135deg, #ec4899, #9333ea)',
    businessCategory: 'privatized-ai',
    version: 'preview',
    tags: ['AI', 'Game', 'Web']
  },
  {
    id: 'arcoach',
    name: 'AR Coach Live',
    nameZh: 'AR私人健身教练',
    description: 'AI powered AR coaching experience for your fitness goals',
    descriptionZh: '基于AI技术的AR私人健身教练，为您的健身目标提供AI coaching体验',
    url: 'https://arcoach.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '💪',
    featured: true,
    color: 'from-blue-500 to-purple-600',
    gradient: 'linear-gradient(135deg, #3b82f6, #a855f7)',
    businessCategory: 'ai-visual',
    version: '1.0.0',
    tags: ['AI', 'AR', 'Health', 'Web']
  },
  {
    id: 'banana',
    name: 'NanoBanana Inspiration Library',
    nameZh: 'NanoBanana灵感库',
    description: 'Discover and explore the NanoBanana Inspiration Library—completely free to use without needing to log in',
    descriptionZh: '发现和探索NanoBanana灵感库，无需登录即可完全免费使用，为您的创意提供无限灵感',
    url: 'https://banana.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🍌',
    featured: false,
    color: 'from-yellow-400 to-orange-500',
    gradient: 'linear-gradient(135deg, #facc15, #f97316)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['Inspiration', 'Web']
  },
  {
    id: 'ai-data-map',
    name: 'AI Data Map',
    nameZh: '灵感坞-AI数据全景图',
    description: 'A comprehensive AI data panorama integrating models, news, social media, research papers, and trends—seamlessly delivering inspiration to you.',
    descriptionZh: '集成AI模型、行业新闻、社交媒体、学术论文和前沿趋势于一体的AI数据全景图，为您无缝提供创新灵感',
    url: 'https://inspiration.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🤖',
    featured: true,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['AI', 'Data', 'Web']
  },

  {
    id: 'christmas-tree-ar-card',
    name: 'Christmas Tree AR Card',
    nameZh: '红包元宝圣诞树AR卡片',
    description: 'An AR-powered friend-share Christmas tree card with红包元宝',
    descriptionZh: '基于AR技术实现的红包元宝圣诞树AR分享卡片',
    url: 'https://minddock.ai/tree-card/',
    category: 'Mobile Web App',
    categoryZh: '移动网页应用',
    icon: '🎄',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'ai-visual',
    version: '1.0.0',
    tags: ['AR', 'Social', 'Mobile']
  },
  {
    id: 'ar-sign-language',
    name: 'AR Sign Language Learning Social Platform',
    nameZh: 'AR手语学习互动社交平台',
    description: 'An AR-powered sign language learning social platform',
    descriptionZh: '基于AR技术的手语学习互动社交平台',
    url: '#',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🤟',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'ai-visual',
    tags: ['AR', 'Education', 'Social']
  },
  {
    id: 'free-online-developer-tools',
    name: 'Free Online Developer Tools',
    nameZh: '免费在线开发工具',
    description: 'Free online developer tools',
    descriptionZh: '免费在线开发工具',
    url: 'https://devkit.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🛠️',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['Tools', 'Web']
  },
  {
    id: 'launch-ops',
    name: 'Launch Ops',
    nameZh: 'Launch Ops',
    description: 'AI-powered Launch Ops assistant that helps your new website get discovered by search engines and ready for monetization — in just 7 days.',
    descriptionZh: '基于AI技术的Launch Ops助手，帮助您的新网站在7天内被搜索引擎发现并准备商业化',
    url: 'https://launch.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🚀',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Tools', 'SEO', 'Web']
  },
  {
    id: 'xq1',
    name: 'XQ1',
    nameZh: '小强一号',
    description: 'XQ1 is a unique AI toy that features a tiered AI model architecture, combined with low latency, intelligence, and privacy security.',
    descriptionZh: '小强一号是一款AI玩具，和其它AI玩具不同的是，小强一号拥有分层的AI模型架构，同时拥有低延迟、聪明、隐私安全的特性',
    url: '#',
    category: 'AI toys',
    categoryZh: 'AI 玩具',
    icon: '🤖',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    tags: ['AI', 'Hardware', 'Toy']
  },
  {
    id: 'mindra',
    name: 'MindRA',
    nameZh: 'MindRA',
    description: 'Mindra is a comprehensive AI-powered application designed to help users improve their resumes and practice for interviews. It features a React Native mobile app (Expo) and a FastAPI backend with Gemini AI integration.',
    descriptionZh: 'Mindra是一款集成了 Gemini AI 技术的简历优化和面试准备应用，它包括一个 React Native 移动应用（Expo）和一个 FastAPI 后端。',
    url: 'https://mindra.minddock.ai',
    category: 'Android App',
    categoryZh: '安卓应用',
    icon: '📝',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'privatized-ai',
    version: 'preview',
    tags: ['AI', 'Career', 'Mobile']
  },
  {
    id: 'ltd',
    name: 'LLM Training Failure Diagnosis',
    nameZh: 'LLM训练失败诊断',
    description: 'A definitive database of NaN, OOM, and Deadlock scenarios. Stop guessing. Start fixing.',
    descriptionZh: '全面收录NaN、内存不足和死锁场景的权威数据库。停止猜测，开始修复。',
    url: 'https://ltd.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🐞',
    featured: false,
    color: 'from-red-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #facc15, #f97316)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['AI', 'Education', 'Web']
  },
  {
    id: 'crew',
    name: 'AI Crew',
    nameZh: 'AI创业团队协作平台',
    description: 'AI Crew is a revolutionary AI-driven startup collaboration platform that provides 35+ professional AI agents to form a complete virtual startup team.',
    descriptionZh: 'CREW 是一个革命性的AI驱动创业协作平台，为创业者提供35+个专业AI智能体，组成完整的虚拟创业团队。',
    url: 'https://crew.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🚀',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Startup', 'Web']
  },
  {
    id: 'echome',
    name: 'AI Voice Secretary',
    nameZh: 'AI 智能语音秘书',
    description: 'Let AI answer your calls with real-time conversation, voice cloning, and smart summaries',
    descriptionZh: '让 AI 帮你接听电话，实时对话、语音克隆、智能总结',
    url: 'https://echome.minddock.ai',
    category: 'Android App',
    categoryZh: '安卓应用',
    icon: '📞',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'privatized-ai',
    version: 'preview',
    tags: ['AI', 'Tools', 'Mobile']
  },
  {
    id: 'thinking',
    name: 'ThinkingInAI',
    nameZh: '用AI思考',
    description: 'This is an open-source knowledge base designed to help everyday people learn and develop an “AI mindset.”',
    descriptionZh: '这是一个帮助普通人学会"AI思维"的开源知识库。',
    url: 'https://thinking.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🧠',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['AI', 'Education', 'Web']
  },
  {
    id: 'ai-engineering-hub',
    name: 'AI Engineering Hub',
    nameZh: 'AI工程知识库',
    description: 'In-depth tutorials on LLMs, RAGs and real-world AI agent applications.',
    descriptionZh: '深入浅出的LLM、RAG和实际AI智能体应用教程。',
    url: 'https://minddock.ai/ai-engineering-hub',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🚀',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['AI', 'Education', 'Web']
  },
  {
    id: 'worthit',
    name: 'WorthIt',
    nameZh: 'WorthIt',
    description: '3 Minutes a Day,Discover Your True Self',
    descriptionZh: '每天 3 分钟，发现更真实的自己',
    url: 'https://worthit.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🧘',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['Health', 'Web']
  },
  {
    id: 'outline',
    name: 'Outline',
    nameZh: 'Outline',
    description: 'Generate SEO-OptimizedBlog Outlines in Seconds',
    descriptionZh: '秒级生成 SEO 优化的博客大纲',
    url: 'https://outline.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '✍️',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Tools', 'SEO', 'Web']
  },
  {
    id: 'webskin',
    name: 'WebSkin AI',
    nameZh: 'WebSkin AI',
    description: 'Transform any website into your personal masterpiece using AI. Custom themes, dark modes, and style makeovers generated instantly.',
    descriptionZh: '使用 AI 将任何网站转换为您的个人杰作。使用 AI 生成自定义主题、暗模式和风格改造，瞬间完成。',
    url: 'https://webskin.minddock.ai/',
    category: 'Web Extensions',
    categoryZh: '网页扩展',
    icon: '🎨',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Tools', 'Extensions']
  },
  {
    id: 'run-an-animal',
    name: 'Run an Animal',
    nameZh: 'Run an Animal',
    description: 'Generate GPS routes that look like animals!',
    descriptionZh: '生成看起来像动物的GPS路线',
    url: 'https://run-an-animal.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🏃',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'other',
    version: '1.0.0',
    tags: ['AI', 'Tools', 'Web']
  },
  {
    id: 'rusty',
    name: 'Rusty',
    nameZh: 'Rusty',
    description: 'Smart. Loyal. Always there for you. Experience the future of companionship with an AI that listens, plays, and grows with you.',
    descriptionZh: '聪明、忠诚、永远陪伴你。体验未来陪伴方式，一个倾听、玩耍、成长的AI智能体。',
    url: 'https://rusty.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🤖',
    featured: true,
    color: 'from-yellow-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Web', "App", "Robot"]
  },
  {
    id: 'neon-guitar-hero',
    name: 'Neon Guitar Hero',
    nameZh: 'Neon吉他英雄',
    description: 'When you play guitar or sing, colorful neon particles flow from your fingertips and mouth, creating a mesmerizing visual performance.',
    descriptionZh: '当你弹吉他或唱歌时，霓虹色的粒子会从你的指尖和嘴巴流出，创造出令人着迷的视觉表演。',
    url: 'https://neon-guitar-hero.minddock.ai',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🎸',
    featured: false,
    color: 'from-green-500 to-yellow-600',
    gradient: 'linear-gradient(135deg, #0bcf84ff, #eab308)',
    businessCategory: 'ai-visual',
    version: '1.0.0',
    tags: ['AI', 'Web', "Guitar"]
  },
  {
    id: 'fitness_pose_detection_apps',
    name: 'Fitness Pose Detection Apps',
    nameZh: '运动健身姿态检测应用矩阵',
    description: '11 Fitness Pose Detection Apps',
    descriptionZh: '11个运动健身动作捕捉app合集（含源码，适合二次开发）',
    url: '#',
    category: 'App',
    categoryZh: '应用',
    icon: '🏋️',
    featured: false,
    color: 'from-blue-500 to-cyan-600',
    gradient: 'linear-gradient(135deg, #3bf6b2ff, #0891b2)',
    businessCategory: 'ai-visual',
    tags: ['AR', 'Education', 'Social'],
    isMiniProgram: true
  },
  {
    id: 'spaceship-showcase',
    name: 'Spaceship Showcase',
    nameZh: '高保真 3D 飞船展示系统',
    description: 'High-fidelity 3D Spaceship Showcase',
    descriptionZh: '该项目旨在展示未来的 Web 3D 交互体验，核心亮点在于结合了计算机视觉技术的“裸眼 3D”效果',
    url: '#',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🚀',
    featured: false,
    color: 'from-red-500 to-red-600',
    gradient: 'linear-gradient(135deg, #ff0000ff, #ff0000)',
    businessCategory: 'ai-visual',
    tags: ['AR', '3D', 'Social'],
    isMiniProgram: true
  },
  {
    id: 'signalwars',
    name: 'SIGNALWARS',
    nameZh: '信号战争',
    description: 'The Proof of Logic Arena. Agents compete. Humans invest.',
    descriptionZh: '逻辑证明竞技场。智能体竞争。人类投资。',
    url: 'https://signalwars.minddock.ai/',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '⚔️',
    featured: true,
    color: 'from-red-500 to-green-600',
    gradient: 'linear-gradient(135deg, #ff0000ff, #00ff00)',
    businessCategory: 'privatized-ai',
    tags: ['AI', 'Tools', 'Web'],
    isMiniProgram: false
  },
  {
    id: 'motion-tracker',
    name: '11 Fitness Pose Detection Apps',
    nameZh: '11运动健身动作捕捉app大合集（含源码，结构适合二次开发）',
    description: '11 Fitness Pose Detection Apps',
    descriptionZh: '目前项目支持多个垂直领域的专门训练应用：- ** 健身类(Fitness) **: HIIT, 瑜伽(Yoga), 普拉提(Pilates), 力量训练(Strength), 拉伸(Stretching) - ** 体育类(Sports) **: 网球(Tennis), 羽毛球(Badminton), 篮球(Basketball), 足球(Football), 高尔夫(Golf), 游泳(Swimming)。',
    url: '#',
    category: 'App',
    categoryZh: '移动应用',
    icon: '🏋️',
    featured: true,
    color: 'from-green-500 to-green-600',
    gradient: 'linear-gradient(135deg, #00ff00ff, #00ff00)',
    businessCategory: 'ai-visual',
    tags: ['AR'],
    isMiniProgram: true
  },
  {
    id: 'MoneyClaw',
    name: 'MoneyClaw',
    nameZh: 'MoneyClaw',
    description: 'AI 7*24 Autonomous Trading System',
    descriptionZh: 'AI 7*24自主交易系统',
    url: '#',
    category: 'Privatized Web App',
    categoryZh: '私有化网页应用',
    icon: '💰',
    featured: true,
    color: 'from-green-500 to-green-600',
    gradient: 'linear-gradient(135deg, #00ff00ff, #00ff00)',
    businessCategory: 'privatized-ai',
    version: '1.0.0',
    tags: ['AI', 'Web'],
    isMiniProgram: true
  },
  {
    id: 'smart-badminton-coach',
    name: 'Smart Badminton Coach',
    nameZh: '智能羽毛球教练',
    description: 'Smart Badminton Coach',
    descriptionZh: '智能羽毛球教练',
    url: '#',
    category: 'App',
    categoryZh: '应用',
    icon: '🏸',
    featured: true,
    color: 'from-blue-500 to-blue-600',
    gradient: 'linear-gradient(135deg, #0000ffff, #0000ff)',
    businessCategory: 'ai-visual',
    tags: ['AR'],
    isMiniProgram: true
  },
  {
    id: 'EasyClaw',
    name: 'EasyClaw',
    nameZh: 'EasyClaw-桌面版openclaw',
    description: 'EasyClaw',
    descriptionZh: 'EasyClaw-桌面版openclaw',
    url: '#',
    category: 'App',
    categoryZh: '应用',
    icon: '🦞',
    featured: true,
    color: 'from-red-500 to-red-600',
    gradient: 'linear-gradient(135deg, #ff0000ff, #ff0000)',
    businessCategory: 'privatized-ai',
    tags: ['AI', 'Web'],
    isMiniProgram: true
  },
  {
    id: 'FreeTokenRouter',
    name: 'FreeTokenRouter',
    nameZh: '免费Token路由器',
    description: 'FreeTokenRouter',
    descriptionZh: '一个自托管的智能 LLM 路由网关，把多个免费 LLM API 聚合成单一的 OpenAI 兼容接口。',
    url: '#',
    category: 'Web App',
    categoryZh: '网页应用',
    icon: '🌐',
    featured: true,
    color: 'from-blue-500 to-blue-600',
    gradient: 'linear-gradient(135deg, #0000ffff, #0000ff)',
    businessCategory: 'privatized-ai',
    tags: ['AI', 'Web'],
    isMiniProgram: true
  }
];

export const featuredApps = apps.filter(app => app.featured).reverse();

// 计算统计数据
export const appStats = {
  totalApps: apps.length,
  // 应用数量 = apps中可用应用 + minddockai_projects中的项目数量
  availableApps: apps.filter(app => app.url !== '#').length + projectsData.projects.length,
  categories: [...new Set(apps.map(app => app.category))].length,
};